import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import excel from 'assets/images/excelIcon.png';
import csv from 'assets/images/csvIcon.png';
import pdf from 'assets/images/pdf.png';
import React from 'react';
import { useMe } from 'hooks/useMe';

const FilesMenu = ({ anchorEl, setAnchorEl, files, fileMenuType, handleFilePick }) => {
    const open = Boolean(anchorEl);
    const { whoami } = useMe();

    const handleClose = (file) => {
        setAnchorEl(null);
    };

    let mafAthletesPermission;
    let mafClubsPermission;
    try {
        mafAthletesPermission = whoami?.permissions?.can('MAFExport', 'Athletes');
        mafClubsPermission = whoami?.permissions?.can('MAFExport', 'Clubs');
    } catch (e) {
        console.log(e);
    }
    const FileMenuIcon = () => {
        if (fileMenuType === 'Excel') return <img style={{ height: '24px' }} src={excel} alt="excel" />;
        if (fileMenuType === 'Csv') return <img style={{ height: '24px' }} src={csv} alt="excel" />;
        if (fileMenuType === 'Pdf') return <img style={{ height: '24px' }} src={pdf} alt="excel" />;
        return null;
    };

    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
                'aria-labelledby': 'basic-button'
            }}
        >
            {files?.map((file) => {
                if (file?.rptId === 30 && !mafAthletesPermission) return null;
                if (file?.rptId === 28 && !mafClubsPermission) return null;
                return (
                    <MenuItem key={file?.rptTitle} onClick={() => handleFilePick(file)}>
                        <ListItemIcon>
                            <FileMenuIcon />
                        </ListItemIcon>
                        {file?.rptTitle}
                    </MenuItem>
                );
            })}
        </Menu>
    );
};

export default FilesMenu;
